export default __webpack_public_path__ + "static/media/img_post6_6.3a7fa49c.png";